// extracted by mini-css-extract-plugin
export default {"editor-save-indicator":"style_editor-save-indicator__FFeyB","indicator":"style_indicator__NxAeW"};